(() => {
  const initManualsPage = () => {
    const section = document.querySelector('[data-manuals-section]');
    if (!section || section.dataset.manualsReady === 'true') return;

    const search = section.querySelector('[data-manual-search]');
    const clearButton = section.querySelector('[data-manual-clear]');
    const emptyClearButton = section.querySelector('[data-manual-empty-clear]');
    const count = section.querySelector('[data-manual-count]');
    const empty = section.querySelector('[data-manual-empty]');
    const filters = [...section.querySelectorAll('[data-manual-filter]')];
    const filterSelect = section.querySelector('[data-manual-filter-select]');
    const emptyQuery = section.querySelector('[data-manual-empty-query]');
    const cards = [...document.querySelectorAll('[data-manual-card]')];
    const libraries = [...document.querySelectorAll('[data-manual-library]')];
    let activeCategory = 'all';
    const productModel = new URLSearchParams(window.location.search).get('model');
    if (productModel) search.value = productModel.trim().slice(0, 80);

    const normalize = (value) => value.trim().toLocaleLowerCase();

    const update = () => {
      const query = normalize(search.value);
      let visibleCount = 0;

      cards.forEach((card) => {
        const matchesSearch = !query || normalize(card.dataset.search || '').includes(query);
        const matchesCategory = activeCategory === 'all' || card.dataset.category === activeCategory;
        const isVisible = matchesSearch && matchesCategory;
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      libraries.forEach((library) => {
        const hasVisibleManual = [...library.querySelectorAll('[data-manual-card]')].some((card) => !card.hidden);
        library.hidden = !hasVisibleManual;
      });

      count.textContent = String(visibleCount);
      empty.hidden = visibleCount !== 0;
      clearButton.hidden = query.length === 0;
      emptyQuery.textContent = query ? ` for “${search.value.trim()}”` : '';
    };

    const clearSearch = () => {
      search.value = '';
      activeCategory = 'all';
      filters.forEach((filter) => {
        const isActive = filter.dataset.manualFilter === 'all';
        filter.classList.toggle('is-active', isActive);
        filter.setAttribute('aria-pressed', String(isActive));
      });
      filterSelect.value = 'all';
      update();
      search.focus();
    };

    search.addEventListener('input', update);
    clearButton.addEventListener('click', clearSearch);
    emptyClearButton.addEventListener('click', clearSearch);

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeCategory = filter.dataset.manualFilter;
        filters.forEach((item) => {
          const isActive = item === filter;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });
        filterSelect.value = activeCategory;
        update();
      });
    });

    filterSelect.addEventListener('change', () => {
      activeCategory = filterSelect.value;
      filters.forEach((item) => {
        const isActive = item.dataset.manualFilter === activeCategory;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', String(isActive));
      });
      update();
    });

    section.dataset.manualsReady = 'true';
    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initManualsPage, { once: true });
  } else {
    initManualsPage();
  }

  document.addEventListener('shopify:section:load', initManualsPage);
})();
